/** Minimum time between two registration confirmation emails; the backend enforces the same cooldown. */
export const CONFIRMATION_RESEND_COOLDOWN_MS = 60_000

const SENT_AT_KEY = 'bounce.confirmation-email-sent-at'

/**
 * Remembers (in this browser) when a confirmation email was last sent, so the resend button can wait out the cooldown
 * after a reload too. Storage may be unavailable; the backend still rejects early resends then.
 */
export const rememberConfirmationEmailSent = (email: string) => {
  try {
    localStorage.setItem(SENT_AT_KEY, JSON.stringify({ email, at: Date.now() }))
  } catch {
    // ignore
  }
}

export const confirmationEmailSentAt = (email: string): number | null => {
  try {
    const stored = JSON.parse(localStorage.getItem(SENT_AT_KEY) ?? 'null') as { email?: string; at?: number } | null
    return stored?.email === email && typeof stored.at === 'number' ? stored.at : null
  } catch {
    return null
  }
}
